module.exports = __webpack_public_path__ + "static/media/fonts-3.2e53f812.svg";